import {sha512} from 'js-sha512';
import md5 from 'js-md5';
import {APP_URL, getRnd} from 'lib/utils/urlUtils';
import {callAsyncBackend} from "./call-authorized-backend";

const authURL = `${APP_URL}/auth`;

export const signIn = async (customerId, password) => {
    const url = new URL(authURL);
    url.searchParams.set('rnd', getRnd());
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify({
            login: customerId,
            password: sha512(password),
            cut: md5(password),
        }),
        credentials: 'same-origin',
    });
    const data = await response.json();

    if (!response.ok) {
        throw data;
    }

    return {
        token: data.token,
    };
};

export const pullConfiguration = async (token) => {
    const url = new URL(`${APP_URL}/service/che_data_service/rest/config/portal`);
    url.searchParams.set('rnd', getRnd());

    const callBackend = async () => {
        return await fetch(url, {
            headers: {
                'Token': token,
            }
        });
    };

    const handleAsyncSuccessResponse = async (response) => {
        const configuration = await response.json();
        localStorage.setItem('configuration', JSON.stringify(configuration));
    };

    const handleAsyncErrorResponse = async () => {
        localStorage.removeItem('token');

        throw new Error('Failed to pull configuration');
    };

    return callAsyncBackend(callBackend, handleAsyncSuccessResponse, handleAsyncErrorResponse);
};
